import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import BillingService from "../../../Services/BillingService";
import Preview from "../../../Assets/Icons/visibility.svg";
import {
  FaChevronLeft,
  FaChevronRight,
  FaFilter,
  FaSearch,
} from "react-icons/fa";
import Layouts from "../../Layouts";
import {
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  message,
  Modal,
  Row,
  Spin,
} from "antd";
import moment from "moment";
import BillingPrint from "../Payments/BillingPrint";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import PatientQueue from "../VCPage/PatientQueue";
import Draggable from "react-draggable";
import { IoIosCloseCircle } from "react-icons/io";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import nodatafound from "../../../Assets/Icons/NoDataCard2.svg";

const BillingReports = () => {
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const INITIAL_FILTERS = {
    patientName: "",
    patientId: "",
    transactionId: "",
    pageNo: 1,
    userId: loginResultObject?.user.userId,
    clinic_id: loginResultObject?.user.clinic_Id,
    fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
    toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
    statuses: "1,4",
  };
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [hasNextPage, setHasNextPage] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [billModal, setBillModal] = useState(false);
  const [billingRecord, setBillingRecord] = useState({});
  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const [formData, setFormData] = useState({
    patientName: "",
    patientId: "",
    transactionId: "",
    serviceCode: "",
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isDragging = useRef(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData({
      patientName: "",
      patientId: "",
      transactionId: "",
    });
  };

  const fetchPaymentReports = async () => {
    setLoading(true);
    try {
      const payload = {
        ...filters,
      };

      const res = await BillingService.BillingRecordsList(payload);
      setList(res.data);
      setHasNextPage(res.data.length == ITEMS_PER_PAGE);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentReports();
  }, [filters]);

  const applyFilter = (updatedValues) => {
    setFilters((prev) => ({
      ...prev,
      ...updatedValues,
    }));
    setIsFilterApplied(true);
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({
      ...prev,
      pageNo: newPage,
    }));
  };

  const clearFilters = () => {
    setFilters(INITIAL_FILTERS);
    setIsFilterApplied(false);
    setFormData({
      patientName: "",
      patientId: "",
      transactionId: "",
    });
  };

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      userId: loginResultObject?.user.userId,
      clinic_id: loginResultObject?.user.clinic_Id,
      fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
      toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
    }));
  }, []);

  const convertUTCDateLocal = (utcDate, format = "DD/MM/YYYY, hh:mm A") => {
    const localDate = dayjs.utc(utcDate).local();
    return localDate.format(format);
  };

  const getServiceCodeLabel = (code) => {
    const map = {
      APPT_VIDEO: "Video",
      APPT_AUDIO: "Audio",
      APPT_HOMEVISIT: "Home",
      APPT_INPERSON: "Inperson",
    };
    return map[code] || null;
  };

  const handleMonthFilter = (value) => {
    const formattedDate = "01";
    const formattedMonth = value.format("MM");
    const formattedYear = value.format("YYYY");
    const fromDate = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    const fromDateMoment = moment(fromDate, "MM/DD/YYYY");
    const lastDayOfMonth = fromDateMoment.endOf("month").format("MM/DD/YYYY");
    const toDate = lastDayOfMonth;

    setFilters((prev) => ({
      ...prev,
      fromDate: fromDate,
      toDate: toDate,
      pageNo: 1,
    }));
    setIsFilterApplied(true);
  };

  const handleFinish = () => {
    const { patientId, patientName, transactionId } = formData;
    if (!patientId && !patientName && !transactionId) {
      message.warning("Enter at least one value.");
      return;
    }
    applyFilter({
      patientId: patientId,
      patientName: patientName,
      transactionId: transactionId,
    });
    setIsModalOpen(false);
  };

  const handleBillingPreview = (record) => {
    if (record.status !== 1) {
      message.error("Payment is not completed");
      return;
    }
    setBillingRecord(record);
    setBillModal(true);
  };
  const closeBillingModal = () => {
    setBillModal(false);
    setBillingRecord({});
  };

  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };
  const onClose = () => {
    setIsDrawerOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };
  return (
    <Layouts>
      <div className="flex flex-col h-full">
        <div className="font-bold">Billing Reports</div>
        <div className="flex flex-col md:flex-row gap-3 md:gap-0">
          {/* Search */}
          <div className="flex justify-end items-center w-full md:w-[60%]">
            <Input
              className="w-full md:w-[60%]"
              placeholder="Search Patient"
              value={filters.patientName}
              onChange={(e) => applyFilter({ patientName: e.target.value })}
              suffix={
                <button className="bg-white font-semibold p-1 md:p-2 rounded-md">
                  <FaSearch />
                </button>
              }
            />
          </div>

          {/* Filters */}
          <div className="flex flex-wrap md:flex-nowrap justify-end gap-2 w-full md:w-[40%]">
            {isFilterApplied && (
              <button
                onClick={clearFilters}
                className="text-white bg-brand-primaryColor font-semibold px-3 py-2 rounded-md flex items-center text-sm md:text-base"
              >
                Clear
              </button>
            )}

            <div className="flex-1 md:flex-none min-w-[120px]">
              <DatePicker
                onChange={handleMonthFilter}
                picker="month"
                format="MMM YYYY"
                value={filters.fromDate ? dayjs(filters.fromDate) : null}
                allowClear={false}
                className="h-[40px] w-full"
              />
            </div>

            <div className="flex items-center justify-end">
              <button
                className="text-white bg-brand-primaryColor font-semibold px-3 py-2 rounded-md flex items-center text-sm md:text-base whitespace-nowrap"
                onClick={showModal}
              >
                <FaFilter className="mr-1" />
                Filter
              </button>
            </div>
          </div>
        </div>

        <div className="w-full mt-5 scrollwidth overflow-x-scroll  rounded-md">
          {loading && (
            <div className="h-screen flex items-center justify-center">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          )}

          {!loading && list.length === 0 && (
            <div className="flex flex-col items-center justify-center h-[inherit]">
              <img src={nodatafound} alt="nodatafound" />
              <p className="font-medium text-xl">No Records found!!</p>
            </div>
          )}

          {!loading && list.length > 0 && (
            <table className="w-full border-collapse">
              <thead>
                <tr>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Patient Name
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Service ID{" "}
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Paid Date
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Type of Service
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Mode Of Payment
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Transaction ID
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Payment Status
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Amount
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Discount Amount
                  </th>
                  <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Paid Amount
                  </th>
                  {/* <th className="p-3 whitespace-nowrap font-sans font-semibold">
                    Invoice
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {list.map((record, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                  >
                    <td className="p-3 whitespace-nowrap border-b">
                      <div className="font-sans font-normal ">
                        <span>{record.patientName}</span>
                      </div>
                      <div className="text-[13px] font-sans">
                        {record.patientId}
                      </div>
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.serviceTransId}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal">
                      {convertUTCDateLocal(record.paymentDate)}{" "}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.serviceName}
                      {getServiceCodeLabel(record.appointmentServiceCode) && (
                        <span className="ml-1 text-xs text-gray-500 font-medium">
                          ({getServiceCodeLabel(record.appointmentServiceCode)})
                        </span>
                      )}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.paymode}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.transactionId}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      <span
                        className={`px-4 py-2 rounded-md font-sans font-normal text-sm w-[104px] h-[28] ${
                          record.status
                            ? "bg-[#31E4A81A] text-green-600"
                            : "bg-[#FF60601A] text-red-600"
                        }`}
                      >
                        {record.status == 1 ? "Completed" : "Pending"}
                      </span>
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.amount}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record?.discountAmount != null &&
                      record?.discountAmount !== 0
                        ? record?.discountAmount
                        : record?.membershipDiscount != null &&
                            record?.membershipDiscount !== 0
                          ? record?.membershipDiscount
                          : "0"}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.paidAmount}
                    </td>
                    {/* <td className="px-4 py-2 text-center  font-sans font-normal ">
                      <div
                        onClick={() => handleBillingPreview(record)}
                        className="rounded-[50%] w-8 h-8 flex items-center justify-center bg-[#DEF3F2]"
                      >
                        <img
                          src={Preview}
                          alt="Preview"
                          className="w-4 h-4 border-none cursor-pointer"
                        />
                      </div>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
          <div className="flex items-center justify-center space-x-2">
            <button
              className={`p-2 rounded-md ${
                filters.pageNo === 1
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
              }`}
              onClick={() => handlePageChange(filters.pageNo - 1)}
              disabled={filters.pageNo === 1}
            >
              <FaChevronLeft className="text-[#189FAA]" />
            </button>

            {filters.pageNo > 2 && (
              <>
                <button
                  className="px-3 py-1  text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                  onClick={() => handlePageChange(1)}
                >
                  1
                </button>
                {filters.pageNo > 3 && (
                  <span className="text-gray-500">...</span>
                )}
              </>
            )}

            {filters.pageNo > 1 && (
              <button
                className="px-3 py-1  text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                onClick={() => handlePageChange(filters.pageNo - 1)}
              >
                {filters.pageNo - 1}
              </button>
            )}

            <button className="px-3 py-1 rounded-md bg-teal-500 text-white text-sm">
              {filters.pageNo}
            </button>

            {hasNextPage && (
              <button
                className="px-3 py-1  text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                onClick={() => handlePageChange(filters.pageNo + 1)}
              >
                {filters.pageNo + 1}
              </button>
            )}

            <button
              className={`p-2 rounded-md ${
                !hasNextPage
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
              }`}
              onClick={() => handlePageChange(filters.pageNo + 1)}
              disabled={!hasNextPage}
            >
              <FaChevronRight className="text-[#189FAA]" />
            </button>
          </div>
        </div>
      </div>
      <Modal
        title="Biling Reports Filter"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={300}
      >
        <Form className="" name="trigger" layout="vertical">
          <div className="flex flex-col gap-2 my-4">
            <div className="relative mt-4 ">
              <label
                htmlFor="patientname"
                className="absolute -top-3 z-10 left-2 bg-white px-1 "
              >
                Patient Name
              </label>
              <Input
                type="text"
                id="patientname"
                placeholder=""
                name="patientName"
                value={formData.patientName}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
            </div>

            <div className="relative mt-4 ">
              <label
                htmlFor="patientId"
                className="absolute -top-3 z-10 left-2 bg-white px-1 "
              >
                Patient ID
              </label>
              <Input
                type="text"
                id="patientId"
                placeholder=""
                name="patientId"
                value={formData.patientId}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
            </div>
            <div className="relative mt-4 ">
              <label
                htmlFor="transactionId"
                className="absolute -top-3 z-10 left-2 bg-white px-1 "
              >
                Transaction ID{" "}
              </label>
              <Input
                type="text"
                id="transactionId"
                name="transactionId"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
                placeholder=""
                value={formData.transactionId}
              />
            </div>
          </div>

          <Form.Item>
            <div className="flex justify-end  mt-3  border-brand-colorBorder gap-3 pt-2">
              <button
                className="h-[32px] Btnwhite rounded-md w-[82px] border-gray-600 border-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="h-[32px] w-[118px] text-white rounded-md"
                type="primary"
                onClick={() => handleFinish()}
              >
                Filter
              </button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <div>
        {/* patient queue design */}
        {isVerticalOpen ? (
          <Draggable
            onStart={() => {
              isDragging.current = false;
            }}
            onDrag={() => {
              isDragging.current = true;
            }}
          >
            <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
              <div
                className="hidden md:block relative mb-5 cursor-pointer"
                onClick={closeCircle}
              >
                <IoIosCloseCircle className="hidden md:block absolute text-red-400 mb-1 right-0 top-0" />
              </div>
              <img
                src={patientqueue}
                alt="patientqueue"
                className="cursor-pointer"
                title="Patient Queue"
                onClick={() => {
                  if (!isDragging.current) {
                    showDrawer(); // ✅ only real click
                  }
                }}
                draggable={false}
                onTouchEnd={showDrawer}
              />
            </div>
          </Draggable>
        ) : (
          <div
            className="vertical"
            style={{ marginTop: "16rem" }}
            onClick={handleClick}
          >
            <p className="vertical-p">
              <div className="vertical-icon-dashboard">
                <MdKeyboardDoubleArrowUp />
              </div>
              Queue
            </p>
          </div>
        )}

        {isDrawerOpen && <PatientQueue onClose={onClose} />}

        {/* patient queue design end */}

        {billModal && (
          <Modal
            title="Invoice Bill"
            width={1000}
            footer={null}
            open={billModal}
            onCancel={closeBillingModal}
          >
            <BillingPrint
              billingRecord={billingRecord}
              loginResultObject={loginResultObject}
            />
          </Modal>
        )}
      </div>
    </Layouts>
  );
};

export default BillingReports;
